import type { ModifiersType } from '@utils';
import { createClsNameMap, mapModifiers } from '@utils';

const clsNameMap = createClsNameMap({
  elements: {
    path: createClsNameMap(),
  },
  modifiers: ['right', 'down'],
})('arrow-icon');

export type ArrowIconProps = {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
  modifiers?: ModifiersType<typeof clsNameMap>;
};

export const ArrowIcon = ({ width = 7, height = 12, modifiers, style }: ArrowIconProps) => {
  return (
    <svg
      style={style}
      className={mapModifiers(clsNameMap, modifiers)}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      role='img'
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
    >
      <path
        className={clsNameMap.elm('path')}
        d='M6.58942 0.610713C6.26398 0.285274 5.73635 0.285274 5.41091 0.610713L0.611415 5.41021C0.455135 5.56649 0.366829 5.77895 0.366829 5.99996C0.366829 6.22098 0.454629 6.43294 0.610909 6.58922L5.41091 11.3892C5.73635 11.7147 6.26398 11.7147 6.58942 11.3892C6.91486 11.0638 6.91486 10.5362 6.58942 10.2107L2.37867 5.99996L6.58942 1.78922C6.91486 1.46379 6.91486 0.936153 6.58942 0.610713Z'
      />
    </svg>
  );
};
